/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ViewerControllerIframe from '../controller/viewer-controller-iframe';

/**
 * @import { IElement } from '../../iframe'
 * @import { ViewerSourceCreator } from '../source'
 * @import { ViewerType } from '../../viewer/type'
 */

/**
 * Typ média widget.
 * @implements {ViewerType}
 */
export default class ViewerTypeWidget {
  /**
   * Vytvoří instanci.
   * @param {number} loadDelay
   * @param {ViewerSourceCreator<HTMLIFrameElement>} sourceCreator
   */
  constructor(loadDelay, sourceCreator) {
    this.loadDelay = loadDelay;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return new ViewerControllerIframe(
      /** @type {IElement} */ (el),
      this.loadDelay
    );
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    // Weby nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  async getUrl(medium) {
    return await medium.onlineUrl;
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return false;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    // U webových stránek se moc nepočítá s tím, že by byly spuštěné na pozadí.
    // Dělá to problémy při naslouchání na události, např. události ovládání.
    // Byl řešen problém s autofocus, který se nechoval při preloadu správně.
    // Také nelze jednoduše vypnout zvuky, které mohou vznikat.
    // Proto je preload zakázaný.
    return false;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return false;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    return true;
  }
}
